import { CloseIcon } from "asset/icons";
import FormSteps from "component/form/formSteps";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import AddItemDetails from "./createShipmentSteps/AddItemDetails";
import AddShipmentDetails from "./createShipmentSteps/AddShipmentDetails";
import AddPaymentInfo from "./createShipmentSteps/AddPaymentInfo";
import AddReceiverInfo from "./createShipmentSteps/AddReceiverInfo";
import ShipmentSummary from "./createShipmentSteps/ShipmentSummary";
import {
    ADD_ITEM_DETAILS,
    ADD_PAYMENT_INFO,
    ADD_RECEIVER_INFO,
    ADD_SHIPMENT_DETAILS,
    optionalCostList,
    SHIPMENT_SUMMARY,
    shippingType,
} from "constants/global";
import Swal from "sweetalert2";
import { useMutation } from "react-query";
import {
    handleAddingPaymentDetails,
    handleAddShipmentDetails,
    handleCreateShipment,
    handleEditShipment,
} from "api/fetchers";
import { validateArrayOfObjects, validateShippingDetails } from "component/flex/utils";
import { useSelector } from "react-redux";
import CurrencyModal from "component/currencyModal";
import NG from "../../../asset/images/NG.png";
import SuccessShipmentModal from "component/flex/shipments/components/modals/SuccessShipmentModal";
import { toast } from "react-toastify";

const CreateShipment = () => {
    const business = useSelector((state) => state.business);
    const [shippingDetailsStep, setShippingDetailsStep] = useState(ADD_ITEM_DETAILS);
    const [addDocs, setAddDocs] = useState(false);
    const [file, setFile] = useState();
    const [shipmentSummary, setShipmentSummary] = useState();
    const [splitPaymentPercentage, setSplitPaymentPercentage] = useState([]);
    const [firstStepDetails, setFirstStepDetails] = useState({
        itemName: "",
        containerType: "",
        loadType: "",
        packageType: "",
        quantity: "",
        weight: "",
        length: "",
        width: "",
        height: "",
        description: "",
        document: null,
    });
    const [shippingLegs, setShippingLegs] = useState([
        {
            id: Date.now(),
            type: "",
            departurePort: "",
            destinationPort: "",
            shippingLine: "",
            clearingAgent: null,
            dropOffDate: "",
            isClearingAgent: false,
            document: null,
        },
    ]);
    const [paymentDetails, setPaymentDetails] = useState({
        clearingFee: null,
        truckingFee: null,
        shippingFee: null,
    });
    const [additionalCost, setAdditionalCost] = useState([
        {
            id: Date.now(),
            additionalCost: null,
            feeType: null,
        },
    ]);
    const [orderDimensionsList, setOrderDimensionsList] = useState([]);
    const [shipmentId, setShipmentId] = useState(null);
    const [showCurrency, setShowCurrency] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState({
        img: NG,
        name: "NGN",
    });
    const [paymentTerm, setPaymentTerm] = useState("");
    const [isReceiver, setIsReceiver] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState();
    const [selectedUser, setSelectedUser] = useState();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [searchParams] = useSearchParams();
    const isEditing = searchParams.get("edit");
    const state = useLocation();
    const dataToEdit = useMemo(() => state?.state?.shipmentData ?? false, [state]);
    const handleFirstFormChange = ({ name, value }) => {
        setFirstStepDetails((prev) => ({ ...prev, [name]: value }));
    };

    const { mutateAsync: handleEditSHipmentFunc, isLoading: editingShipmentLoading } = useMutation({
        mutationFn: async (data) => await handleEditShipment(data),
        mutationKey: ["edit-shipment"],
    });

    useEffect(() => {
        if (dataToEdit) {
            handleFirstFormChange({ name: "itemName", value: dataToEdit?.shipmentTitle });
            handleFirstFormChange({ name: "containerType", value: dataToEdit?.containerType });
            handleFirstFormChange({ name: "loadType", value: dataToEdit?.loadType });
            handleFirstFormChange({ name: "packageType", value: dataToEdit?.packageType });
            handleFirstFormChange({ name: "weight", value: dataToEdit?.totalWeight });
            handleFirstFormChange({ name: "quantity", value: dataToEdit?.totalQuantity });
            handleFirstFormChange({ name: "height", value: dataToEdit?.packageDimention?.height });
            handleFirstFormChange({
                name: "length",
                value: dataToEdit?.packageDimention?.["length"],
            });
            handleFirstFormChange({ name: "width", value: dataToEdit?.packageDimention?.width });
            handleFirstFormChange({ name: "document", value: dataToEdit?.document[0] });
            handleFirstFormChange({
                name: "description",
                value: dataToEdit?.description,
            });
            setShipmentId(dataToEdit?.id);
            // if (dataToEdit?.purchaseOrder?.length) {
            //     setOrderDimensionsList((prev) => [
            //         ...prev,
            //         ...dataToEdit?.purchaseOrder?.map((item) => ({
            //             ...item,
            //         })),
            //     ]);
            // }
            if (dataToEdit?.shippingDetails?.length) {
                setShippingLegs(() =>
                    dataToEdit?.shippingDetails?.map((item) => ({
                        id: item?._id,
                        clearingAgent: {
                            _id: item?.agent,
                            email: item?.agentEmail,
                            name: item?.agentName,
                        },
                        ...item,
                    }))
                );
            }
            const data = {};
            if (dataToEdit?.paymentDetails?.clearingFee) {
                data.clearingFee = dataToEdit?.paymentDetails?.clearingFee;
            }
            if (dataToEdit?.paymentDetails?.truckingFee) {
                data.truckingFee = dataToEdit?.paymentDetails?.truckingFee;
            }
            if (dataToEdit?.paymentDetails?.ShippingFee) {
                data.ShippingFee = dataToEdit?.paymentDetails?.shippingFee;
            }
            if (data && typeof data === "object") {
                Object.entries(data).forEach(([key, value]) => {
                    setPaymentDetails((prev) => ({ ...prev, [key]: value }));
                });
            }
            const filteredFees = Object.fromEntries(
                Object.entries(dataToEdit?.paymentDetails || {}).filter(([_, value]) => value > 0)
            );
            const additionalCosts = Object.entries(filteredFees)
                .filter(
                    ([key]) =>
                        key !== "clearingFee" && key !== "truckingFee" && key !== "shippingFee"
                )
                .map(([key, value], index) => ({
                    id: index + 1,
                    feeType: key,
                    additionalCost: value,
                }));
            setAdditionalCost(additionalCosts);
            setPaymentTerm(dataToEdit?.paymentTerm);
            if (dataToEdit?.receiverEmail || dataToEdit?.receiverName || dataToEdit?.flexUser) {
                setSelectedSupplier({
                    _id: dataToEdit?.receiverBusiness,
                    name: dataToEdit?.receiverName,
                    email: dataToEdit?.receiverEmail,
                });
            }
            if (dataToEdit?.document[0]) {
                setAddDocs(true);
                setFile(dataToEdit?.document[0]);
            }
            if (dataToEdit?.paymentTerm?.startsWith("Split")) {
                const firstSplitValue = dataToEdit?.paymentOne;
                const secondSplitValue = dataToEdit?.paymentTwo;
                setSplitPaymentPercentage([firstSplitValue, secondSplitValue]);
            }
        }
    }, [dataToEdit]);

    useEffect(() => {
        if (isReceiver) {
            setSelectedSupplier(null);
        }
    }, [isReceiver]);

    const addSelectedCurrency = (currency) => {
        setShowCurrency(!showCurrency);
        setSelectedCurrency(currency);
    };

    const { mutateAsync, isLoading: creatingShipmentLoading } = useMutation({
        mutationFn: async (data) => await handleCreateShipment(data),
    });
    const { mutateAsync: asyncAddShippingDetails, isLoading: loadingShippingDetails } = useMutation(
        {
            mutationFn: async (data) => await handleAddShipmentDetails(data),
        }
    );
    const { mutateAsync: asyncPaymentDetails, isLoading: loadingPaymentDetails } = useMutation({
        mutationFn: async (data) => await handleAddingPaymentDetails(data),
    });

    const totalAmount =
        additionalCost.reduce((acc, item) => {
            return item.feeType && acc + Number(item.additionalCost);
        }, 0) +
        Number(paymentDetails.clearingFee) +
        Number(paymentDetails.truckingFee);

    const isFirstStepValid = useMemo(
        () =>
            dataToEdit
                ? { valid: true, message: "Details are valid" }
                : validateShippingDetails(firstStepDetails, [
                      "containerType",
                      "loadType",
                      "packageType",
                      "quantity",
                      "weight",
                      //   "length",
                      //   "width",
                      //   "height",
                      "itemName",
                  ]),
        [firstStepDetails, dataToEdit]
    );

    const isSecondStepValid = useMemo(
        () =>
            dataToEdit
                ? { valid: true, message: "Details are valid" }
                : validateArrayOfObjects(shippingLegs, [
                      //   "departurePort",
                      //   "destinationPort",
                      "shippingLine",
                      "dropOffDate",
                  ]),
        [shippingLegs, dataToEdit]
    );

    const isThirdStepValid = useMemo(
        () =>
            dataToEdit
                ? { valid: true, message: "Details are valid" }
                : validateShippingDetails(paymentDetails, ["clearingFee", "truckingFee"]),
        [paymentDetails]
    );

    const submitFirstForm = async (step) => {
        const {
            containerType,
            loadType,
            itemName,
            packageType,
            weight,
            quantity,
            width,
            height,
            length,
            description,
            document,
        } = firstStepDetails;
        const payload = {
            containerType,
            loadType,
            shipmentTitle: itemName,
            packageType,
            totalWeight: weight,
            totalQuantity: quantity,
            document,
            packageDimention: {
                width,
                height,
                length,
            },
            description,
            purchaseOrder: orderDimensionsList?.map((item) => item?._id),
        };
        if (!document) {
            delete payload["document"];
        }
        if (isEditing) {
            try {
                const response = await handleEditSHipmentFunc({
                    shipmentId: isEditing || shipmentId,
                    ...payload,
                });
                if (response?.status === 200) {
                    setShipmentId(response?.data?.data);
                    return goToStep(step);
                }
            } catch (error) {
                toast.error("An error occurred while editing shipment");
            }
        } else {
            try {
                if (isFirstStepValid.valid) {
                    if (shipmentId) {
                        return goToStep(step);
                    } else {
                        const response = await mutateAsync(payload);
                        if (response?.data?.data) {
                            setShipmentId(response?.data?.data);
                            return goToStep(step);
                        }
                    }
                } else {
                    Swal.fire({
                        text: isFirstStepValid.message,
                        icon: "error",
                        confirmButtonText: "Close",
                        width: "280px",
                        confirmButtonColor: "crimson",
                    });
                }
            } catch (error) {
                Swal.fire({
                    text: "An error occurred while creating shipment",
                    icon: "error",
                    confirmButtonText: "Close",
                    width: "280px",
                    confirmButtonColor: "crimson",
                });
            }
        }
    };

    const submitSecondForm = async (step) => {
        try {
            if (isSecondStepValid.valid) {
                const response = await asyncAddShippingDetails({
                    shipmentId: shipmentId || isEditing,
                    shipmentLegs: shippingLegs.map(
                        ({
                            type,
                            departurePort,
                            destinationPort,
                            shippingLine,
                            dropOffDate,
                            document,
                            isClearingAgent,
                            clearingAgent,
                        }) => ({
                            type: shippingType?.[type],
                            departurePort,
                            destinationPort,
                            shippingLine,
                            agentName: isClearingAgent ? business?.name : clearingAgent?.name,
                            agentEmail: isClearingAgent ? business?.email : clearingAgent?.email,
                            agent: isClearingAgent ? business?._id : clearingAgent?._id,
                            dropOffDate,
                        })
                    ),
                });
                if (response?.data?.data) {
                    return goToStep(step);
                }
            } else {
                Swal.fire({
                    text: isSecondStepValid.message,
                    icon: "error",
                    confirmButtonText: "Close",
                    width: "280px",
                    confirmButtonColor: "crimson",
                });
            }
        } catch (error) {
            Swal.fire({
                text: error?.response?.data?.message || "An error occurred while creating shipment",
                icon: "error",
                confirmButtonText: "Close",
                width: "280px",
                confirmButtonColor: "crimson",
            });
        }
    };

    const submitPaymentDetails = async (step) => {
        function transformData(arr) {
            return arr.reduce((acc, obj) => {
                acc[obj.feeType] = obj.additionalCost;
                return acc;
            }, {});
        }
        try {
            if (isThirdStepValid.valid) {
                const remainingObj = {};
                optionalCostList.filter(
                    (item) =>
                        !additionalCost.find((cost) => cost.feeType === item.value) &&
                        (remainingObj[item.value] = 0)
                );
                const details = {
                    clearingFee: Number(paymentDetails.clearingFee),
                    truckingFee: Number(paymentDetails.truckingFee),
                    ...transformData(additionalCost),
                    ...remainingObj,
                };
                delete details["null"];
                const payload = {
                    shipmentId: shipmentId || isEditing,
                    paymentDetails: details,
                    currency: selectedCurrency?.name,
                    paymentTerm,
                };
                if (isReceiver || selectedSupplier?._id === business?._id) {
                    payload.isYourself = true;
                } else {
                    payload.flexUser = selectedSupplier?._id;
                }
                if (paymentTerm?.startsWith("Split")) {
                    payload.paymentOne = splitPaymentPercentage[0];
                    payload.paymentTwo = splitPaymentPercentage[1];
                }
                setShipmentSummary(details);
                const response = await asyncPaymentDetails(payload);
                if (response?.status === 400) {
                    Swal.fire({
                        text:
                            typeof response?.response?.data?.message == "string"
                                ? response?.response?.data?.message
                                : response?.response?.data?.message[0] ||
                                  "An error occurred while creating shipment",
                        icon: "error",
                        confirmButtonText: "Close",
                        width: "280px",
                        confirmButtonColor: "crimson",
                    });
                    // return goToStep(step);
                } else if (response?.data?.data) {
                    setShowSuccessModal(true);
                } else {
                    setShowSuccessModal(true);
                }
            } else {
                Swal.fire({
                    text: isThirdStepValid.message,
                    icon: "error",
                    confirmButtonText: "Close",
                    width: "280px",
                    confirmButtonColor: "crimson",
                });
            }
        } catch (error) {
            Swal.fire({
                text:
                    error?.response?.data?.message ||
                    error?.message ||
                    "An error occurred while creating shipment",
                icon: "error",
                confirmButtonText: "Close",
                width: "280px",
                confirmButtonColor: "crimson",
            });
        }
    };

    const isForthStepValid = selectedSupplier || isReceiver;

    const goToStep = (step) => {
        setShippingDetailsStep(step);
    };

    return (
        <div className="bg-[#f6f7fd]">
            <nav className="h-[72px] !m-0 !px-6 !py-0 flex items-center navbar-gradient bg-[#f6f7fd] sticky top-0 z-10">
                <Link to={-1}>
                    <CloseIcon className="*:stroke-[#1D2939] size-[25px] mr-2 -translate-y-[3px]" />
                </Link>

                <h2 className="font-[450] !text-lg text-main-dark !ml-3.5 mr-auto">
                    {!!dataToEdit ? "Edit Shipment" : "Create Shipment"}
                </h2>

                {/* <button
                    className={`text-[#FBFAFF] rounded-lg !px-6 !py-2 font-[450] ${
                        true ? "pointer-events-none !bg-[#D9CDFF]" : "!bg-secondary"
                    }`}
                    onClick={() => {}}
                >
                    Book Shipment
                </button> */}
            </nav>

            <div className="flex md:flex-row justify-between flex-col pl-3 pr-3 md:pl-[70px] md:pr-[20px] !pt-11 !mb-20 gap-x-20">
                {shippingDetailsStep !== SHIPMENT_SUMMARY && (
                    <FormSteps
                        setShippingDetailsStep={setShippingDetailsStep}
                        currentStep={shippingDetailsStep}
                        validateFirstStep={true}
                        validateSecondStep={isFirstStepValid?.valid || shipmentId}
                        validateThirdStep={isFirstStepValid?.valid && isSecondStepValid?.valid}
                        validateFourthStep={
                            isFirstStepValid?.valid &&
                            isSecondStepValid?.valid &&
                            isThirdStepValid?.valid
                        }
                    />
                )}
                <div
                    className={`md:w-[610px] ${
                        shippingDetailsStep === SHIPMENT_SUMMARY ? "mx-auto" : ""
                    }`}
                >
                    {shippingDetailsStep === ADD_ITEM_DETAILS && (
                        <AddItemDetails
                            firstStepDetails={firstStepDetails}
                            handleFirstFormChange={handleFirstFormChange}
                            addDocs={addDocs}
                            setAddDocs={setAddDocs}
                            file={file}
                            setFile={setFile}
                            submitFirstForm={submitFirstForm}
                            setOrderDimensionsList={setOrderDimensionsList}
                            orderDimensionsList={orderDimensionsList}
                            isFirstStepValid={isFirstStepValid}
                            isLoading={creatingShipmentLoading || editingShipmentLoading}
                            additionalCost={additionalCost}
                            setAdditionalCost={setAdditionalCost}
                            isEditing={isEditing}
                        />
                    )}
                    {shippingDetailsStep === ADD_SHIPMENT_DETAILS && (
                        <AddShipmentDetails
                            submitSecondForm={submitSecondForm}
                            goToStep={goToStep}
                            shippingLegs={shippingLegs}
                            setShippingLegs={setShippingLegs}
                            isSecondStepValid={isSecondStepValid}
                            isLoading={loadingShippingDetails}
                            selectedUser={selectedUser}
                            setSelectedUser={setSelectedUser}
                        />
                    )}
                    {shippingDetailsStep === ADD_PAYMENT_INFO && (
                        <AddPaymentInfo
                            submitPaymentDetails={submitPaymentDetails}
                            goToStep={goToStep}
                            selectedCurrency={selectedCurrency}
                            paymentDetails={paymentDetails}
                            setPaymentDetails={setPaymentDetails}
                            isThirdStepValid={isThirdStepValid}
                            paymentTerm={paymentTerm}
                            setPaymentTerm={setPaymentTerm}
                            totalAmount={totalAmount}
                            additionalCost={additionalCost}
                            setAdditionalCost={setAdditionalCost}
                            splitPaymentPercentage={splitPaymentPercentage}
                            setSplitPaymentPercentage={setSplitPaymentPercentage}
                        />
                    )}
                    {shippingDetailsStep === ADD_RECEIVER_INFO && (
                        <AddReceiverInfo
                            isReceiver={isReceiver}
                            setIsReceiver={setIsReceiver}
                            business={business}
                            submitPaymentDetails={submitPaymentDetails}
                            goToStep={goToStep}
                            selectedSupplier={selectedSupplier}
                            setSelectedSupplier={setSelectedSupplier}
                            isForthStepValid={isForthStepValid}
                            isLoading={loadingPaymentDetails}
                        />
                    )}
                    {shippingDetailsStep === SHIPMENT_SUMMARY && (
                        <ShipmentSummary
                            shippingLegs={shippingLegs}
                            goToStep={goToStep}
                            firstStepDetails={firstStepDetails}
                            paymentDetails={paymentDetails}
                            shipmentSummary={shipmentSummary}
                            selectedCurrency={selectedCurrency}
                            paymentTerm={paymentTerm}
                            selectedSupplier={selectedSupplier}
                            totalAmount={totalAmount}
                            submitPaymentDetails={submitPaymentDetails}
                            isLoading={loadingPaymentDetails}
                            additionalCost={additionalCost}
                            isEditing={isEditing}
                            isReceiver={isReceiver}
                        />
                    )}
                </div>

                <div className="flex justify-start w-full my-2 md:justify-end md:w-3/12 md:my-0">
                    {shippingDetailsStep === ADD_PAYMENT_INFO && (
                        <div
                            onClick={() => {
                                setShowCurrency(!showCurrency);
                            }}
                            className="w-full max-w-[285px] cursor-pointer rounded-[8px] border-0 outline-0 bg-white 
                            p-2 flex items-center justify-between relative 
                            text-base font-medium leading-none tracking-[2%] h-[56px]"
                        >
                            <p>Currency</p>
                            <div className="flex items-center gap-1 bg-[#ECEFF3] p-2 rounded-md">
                                <img
                                    src={selectedCurrency.img}
                                    alt={selectedCurrency.name}
                                    className="border-0 size-[15px]"
                                />
                                <span className="text-[#667085] text-[16px] tracking-[2%] leading-[24px] font-semibold">
                                    {selectedCurrency.name}
                                </span>
                                <span className="material-icons" style={{ color: "#101828" }}>
                                    keyboard_arrow_down
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <CurrencyModal
                show={showCurrency}
                setshow={setShowCurrency}
                addseletedcurrency={addSelectedCurrency}
            />
            <SuccessShipmentModal
                shipmentId={isEditing ? isEditing : shipmentId}
                show={showSuccessModal}
                setShow={setShowSuccessModal}
            />
        </div>
    );
};

export default CreateShipment;
